import React, { useEffect } from 'react';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import { Icon } from '@/components';
import { useBoolean } from 'ahooks';
import { RootStore } from '@/models';
import ActionBtn, { ActionProps } from '../ActionBtn';
import styles from './index.less';
import classNames from 'classnames';

interface Props extends Partial<Pick<RootStore, 'meeting'>>, Pick<ActionProps, 'order'> {
  isShow: boolean;
  onClick: (visible: boolean) => void;
  className?: string;
  showMore: boolean;
}
const MoreBtn: React.FC<Props> = inject(({ store }) => {
  return {};
})(
  observer((props) => {
    const { className, isShow, order, onClick, showMore: propsShowMore } = props;
    const { formatMessage } = useIntl();
    const [showMore, { toggle: taggleShowMore, set: setShowMore }] = useBoolean(false);

    useEffect(() => {
      setShowMore(propsShowMore);
    }, [propsShowMore]);

    return (
      <>
        {isShow ? (
          <ActionBtn
            order={order}
            bottomTitle={formatMessage({ id: showMore ? 'COLLAPSE2' : 'MORE' })}
            className={classNames(styles.moreBtn, className)}
            onClick={() => {
              onClick && onClick(!showMore);
              taggleShowMore();
            }}
          >
            <Icon className={styles.icon} name="icon-more" />
          </ActionBtn>
        ) : null}
      </>
    );
  })
);

export default MoreBtn;
